import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import ViewInfo from "../../../Announcements/Announcement.module.css";
import { AxiosInstance } from "../../../../../../axios";
import Loader from "../../../../Loader";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";

export default function ViewRewardPoints() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { STATUS, SEARCH, DATE } = location.state;
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User ID not available in session storage");
  }

  // State variables
  const [formFields, setFormFields] = useState({
    Description: "",
    StartDate: "",
    EndDate: "",
    point_per_hundred: "",
    amount_per_point: "",
    amount_per_hundred: "",
    status: "",
    reward_use: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmations, setShowConfirmations] = useState(false);
  const openModal = () => setShowConfirmations(true);
  const closeModal = () => setShowConfirmations(false);
  // Helper function to map status values
  const mapStatus = (status) => {
    switch (status) {
      case 0:
        return "Expired";
      case 1:
        return "Active";
      case 2:
        return "Upcoming";
      default:
        return "Unknown";
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    setIsLoading(true);

    AxiosInstance.post("api/book/reward_view", {
      id: parseInt(id),
    })
      .then((res) => {
        if (res.data.status === true) {
          const courseData = res.data.data;

          const validityDates = courseData.validity_date
            ? courseData.validity_date.split(" - ")
            : ["_", "_"];

          setFormFields({
            Description: courseData.description || "_",
            point_per_hundred: courseData.point_per_hundred || "_",
            amount_per_point: courseData.amount_per_point || "_",
            amount_per_hundred: courseData.amount_per_hundred || "_",
            StartDate: validityDates[0],
            EndDate: validityDates[1],
            status: mapStatus(courseData.status),
            reward_use: courseData.is_reward_use
          });
          setIsLoading(false);
        } else {
          console.warn("No valid data found in API response");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      });
  }, [id]);

  // Navigation handlers
  const navigateToPreviousScreen = () => {
    navigate(`/RewardPoints`);
  };

  const handleNavigate = (id) => {
    navigate(`/CreateRewardPoints/${id}`);
  };

  const handleBackFilter = () => {
    navigate(`/RewardPoints`, {
      state: {
        filStatus: STATUS,
        filter_search: SEARCH,
        filter_date: DATE
      }
    });
  };
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  // Determine if the Edit button should be enabled
  const isEditButtonEnabled = formFields.status === "Upcoming" || formFields.reward_use == 0;
  const isDeleteButtonEnabled = formFields.status === "Upcoming";
  const handleDelete = () => {
    const updateCoupon = {
      id: id,
    };

    AxiosInstance.post(`api/book/reward_delete`, updateCoupon)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message || "Reward Point deleted successfully.");
          closeModal();
          navigate("/RewardPoints");
        } else {
          toast.error(res.data.message || "Failed to delete coupon.");
        }
      })
      .catch((error) => {
        console.error("Delete error:", error);
        toast.error("Something went wrong while deleting the coupon.");
      });
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      {showConfirmations && (
        <Modal show={showConfirmations} onHide={closeModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <h5 className="ModalHeader mb-0">Delete Reward Point</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-4 col-md-7">
              <p className="text-start" style={{ minHeight: "100px" }}>
                Are you sure you want to delete this Reward Point?
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end w-100">
              <button
                className={`${ViewInfo.dont_delete} bg-white secondaryButton border-0 mx-2`}
                onClick={closeModal}
              >
                No, Keep It
              </button>
              <button
                className="primaryButton border-0 mx-2"
                onClick={handleDelete}
              >
                Yes, Delete
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      <div className={`${ViewInfo.CourseInfoSec} BathHeader global_container`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Reward Point</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link
                  onClick={handleBackFilter}
                  to="javascript:void(0)"
                  className="secondaryButton"
                  variant="secondary"
                >
                  Back to Reward Points
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={
                    !isDeleteButtonEnabled ? () => { } : () => openModal()
                  }
                  className={`primaryButton ${!isDeleteButtonEnabled ? "disabled_btn" : ""
                    }`}
                  variant="primary"
                  style={{
                    pointerEvents: isDeleteButtonEnabled ? "auto" : "disabled_btn",
                  }}
                >
                  <span className="material-icons me-1 fs-5 align-middle text-white">
                    border_color
                  </span>{" "}
                  Delete Reward Point
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  // onClick={
                  //   !isEditButtonEnabled ? () => { } : () => handleNavigate(id)
                  // }
                  onClick={() => handleNavigate(id)}
                  // className={`primaryButton ${!isEditButtonEnabled ? "disabled_btn" : ""  }`}
                  className={`primaryButton`}

                  variant="primary"
                  // style={{
                  //   pointerEvents: isEditButtonEnabled ? "auto" : "disabled_btn",
                  // }}
                >
                  <span className="material-icons me-1 fs-5 align-middle text-white">
                    border_color
                  </span>{" "}
                  Edit Reward Point
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Reward Point Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Description</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.Description || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Points per ₹100</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.point_per_hundred || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Amount Per Point</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.amount_per_point || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Amount Per ₹100</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.amount_per_hundred || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Validity Date</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.StartDate ? formFields.StartDate : "_"} -{" "}
                    {formFields.EndDate ? formFields.EndDate : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Status</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.status || "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </>


  );
}
